import { useEffect, useState } from 'react';
import { X, PenLine, Loader2, RefreshCw } from 'lucide-react';
import api from '../../services/api';
import QrcVerdictView from './QrcVerdictView';

const when = (d) => {
    if (!d) return '';
    const dt = new Date(String(d).replace(' ', 'T'));
    return dt.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
        + ' à ' + dt.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
};

/**
 * Relecture d'une correction rédigée enregistrée : l'énoncé, la réponse telle
 * qu'elle a été soumise, et le verdict complet reconstruit par le serveur
 * (qrc-history.php?attempt_id=), identique à celui rendu à la correction.
 * Ouvert depuis l'onglet Résultats et depuis le player (« Voir ma dernière correction »).
 */
export default function QrcAttemptModal({ attemptId, accentColor, onClose }) {
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let alive = true;
        setData(null); setErr(null);
        api.get('/qcm/qrc-history.php', { params: { attempt_id: attemptId } })
            .then(({ data: d }) => { if (alive) setData(d.data); })
            .catch(e => { if (alive) setErr(e.response?.data?.message || 'Correction indisponible'); });
        return () => { alive = false; };
    }, [attemptId]);

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    const a = data?.attempt;
    return (
        <div className="checkout-modal-overlay" onClick={onClose}>
            <div className="checkout-modal qrc-attempt-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '760px' }}>
                <div className="checkout-modal__header" style={{ background: accentColor || 'var(--primary, #7c3aed)', color: '#fff' }}>
                    <span className="checkout-modal__title"><PenLine size={17} /> Ma correction</span>
                    <button type="button" className="qrc-attempt-modal__close" onClick={onClose} aria-label="Fermer"><X size={18} /></button>
                </div>
                <div className="checkout-modal__body qrc-attempt-modal__body">
                    {err && <p className="qrcp-err">{err}</p>}
                    {!err && !data && <p className="qrc-attempt-modal__loading"><Loader2 size={15} className="spin" /> Chargement…</p>}
                    {a && (
                        <div className="qrcp qrcp--modal" style={accentColor ? { '--qrcp-accent': accentColor } : undefined}>
                            <div className="qrc-attempt-modal__meta">
                                {a.sous_sujet_label}{a.matiere ? ` · ${a.matiere}` : ''} · {when(a.created_at)}
                                {a.qcm_mastery_snapshot !== null && a.qcm_mastery_snapshot !== undefined && (
                                    <> · maîtrise QCM du sujet ce jour-là : {Math.round(a.qcm_mastery_snapshot)} %</>
                                )}
                            </div>
                            {a.newer_bareme && (
                                <div className="qrc-attempt-modal__newer">
                                    <RefreshCw size={14} />
                                    <span>
                                        <strong>Nouvelle version de correction disponible.</strong> Le barème de cette question a été précisé depuis ta correction.
                                        Ce résultat reste celui de ta réponse d’origine ; retente la question pour obtenir une correction selon la nouvelle version.
                                    </span>
                                </div>
                            )}
                            <p className="qrc-attempt-modal__enonce">{a.enonce}</p>
                            <div className="qrcp-showcase-answer">
                                <span>Ma réponse</span>
                                <p>{a.answer_text}</p>
                            </div>
                            <QrcVerdictView verdict={data.verdict} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
